/*
 *
 * Tickets constants
 *
 */

export const DEFAULT_ACTION = 'app/Agenda/DEFAULT_ACTION';
